import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import OrderAdminRepository from "../../../../repository/Admin/OrderAdminRepository";

// TODO subject to change according to API request and response model.
export const getAdminOrderList = createAsyncThunk('get_admin_order_list', async (params) => {
  return await new OrderAdminRepository().getAdminOrderList(params);
});

const slice = createSlice({
  name: "AdminOrdersList",
  initialState: {
    totalRecords: 0,
    adminOrderList: [],
  },
  reducers: {
    setAdminOrderList: {
      reducer: (state, action) => {
        state.adminOrderList = action.payload;
        return state;
      },
    },
  },
  extraReducers: {
    // TODO subject to change as per the API
    [getAdminOrderList.fulfilled]: (state, action) => {
      state.adminOrderList = action.payload;
      state.totalRecords = action.payload?.length;
    },
  },
});

export const { setAdminOrderList } = slice.actions;

export default slice.reducer;